// REQ-VAL-02 — solo esquema https, sin whitelist de dominio (T&C/Política son URLs externas al tenant)
const HTTPS_REGEX = /^https:\/\//;

export function isValidHttpsUrl(value: string | null | undefined): boolean {
  return !!value && HTTPS_REGEX.test(value);
}
